import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";

import { PER_DIEMS_LINE_ITEM_TYPES } from "../../../sharedCode/metadata";
import { TicketExtended } from "../../../Utils/TypeExtensions";

export default function PerDiemsMenuContent(ticket: TicketExtended, title: string, validationResults: ValidationResult[]): MenuCardContent {
    const applicableLineItems = ticket?.LineItems?.filter(
        (r) => r?.quantity && r?.quantity > 0 && PER_DIEMS_LINE_ITEM_TYPES.findIndex((id) => r && id === r.line_item_type_id) >= 0
    );

    const lineItemCount = applicableLineItems?.length ?? 0;

    const details = <Typography textAlign={"center"}>{lineItemCount} FOUND</Typography>;
    const validationMessages = TicketErrorHelper.getCardErrors(validationResults, title);

    return { details, validationMessages };
}
